import { PersonalAccountAddressInfoType } from '@screens/PersonalAccount';
import { ID_ARTICLE_ATTRIBUTE } from '@shared/constants/keys';
import { OrderProductType } from '@shared/types/order';

export const formatOrderString = (obj: {
  address?: PersonalAccountAddressInfoType;
  total?: number | null;
  products?: Pick<OrderProductType, 'productData' | 'quantity'>[];
}): string => {
  // Формируем блок товаров
  let productsString = 'Товары: \n';
  if (obj.products && obj.products.length > 0) {
    productsString += obj.products
      .map(
        (product) =>
          `Наименование: "${product.productData.name}", Артикул: "${product.productData.props[ID_ARTICLE_ATTRIBUTE]?.values[0].value}", Количество: "${product.quantity}"`
      )
      .join('; \n');
  } else {
    productsString += 'Нет товаров';
  }

  // Формируем блок суммы
  const totalString = `\nСумма заказа ${obj.total ?? 0}р;`;

  // Формируем блок адреса
  let addressString = '\nАдрес: ';
  if (obj.address) {
    const parts = [];

    const region = formatValue(obj.address.region);
    const city = formatValue(obj.address.city);
    const street = formatValue(obj.address.street);
    const house = formatValue(obj.address.house);
    const corpus = formatValue(obj.address.corpus);
    const floor = formatValue(obj.address.floor);
    const apartment = formatValue(obj.address.apartment);
    const postalCode = formatValue(obj.address.postalCode);

    if (region) parts.push(`Регион/Область ${region}`);
    if (city) parts.push(`Город ${city}`);
    if (street) parts.push(`Улица ${street}`);
    if (house) parts.push(`Дом ${house}`);
    if (corpus) parts.push(`Корпус ${corpus}`);
    if (floor) parts.push(`Этаж ${floor}`);
    if (apartment) parts.push(`Квартира ${apartment}`);
    if (postalCode) parts.push(`Почтовый индекс ${postalCode}`);

    addressString += parts.join(', ');
  } else {
    addressString += ''; // пустая строка, если адреса нет
  }

  return productsString + totalString + addressString;
};

// Вспомогательная функция для преобразования значения в строку
const formatValue = (value: string | number | undefined | null): string => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};
